var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box content"},[_c('h1',{staticClass:"title"},[_vm._v("Shreddify")]),_c('h2',{staticClass:"subtitle has-text-weight-normal"},[_vm._v("Get shredded")]),_c('blockquote',[_vm._v(" Shreddify aims to provide you with tools that will help you get shredded. Resources you'll find here will help you with both your training and nutrition. ")])])
}]

export { render, staticRenderFns }